var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Pagination from '../widgets/Pagination';
import AnimateHeight from 'react-animate-height';
import { injectIntl, FormattedRelativeTime } from 'react-intl';
import Icon from '../components/Icon';
import Translate from './Translate';
import { selectUnit } from '@formatjs/intl-utils';

var InternalMessagesInbox = function (_PureComponent) {
  _inherits(InternalMessagesInbox, _PureComponent);

  function InternalMessagesInbox(props) {
    _classCallCheck(this, InternalMessagesInbox);

    var _this = _possibleConstructorReturn(this, (InternalMessagesInbox.__proto__ || Object.getPrototypeOf(InternalMessagesInbox)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        messages = _this$props.messages,
        initialMessage = _this$props.initialMessage,
        pageSize = _this$props.pageSize;


    var currentPage = 1;
    var messagePos = -1;

    if (initialMessage) {
      messagePos = messages.map(function (e) {
        return e.Id;
      }).indexOf(initialMessage);
      currentPage = Math.floor(messagePos / pageSize) + 1;
      currentPage = currentPage > 0 ? currentPage : 1;
    }

    var activeMessage = initialMessage && messagePos >= 0 ? initialMessage : false;

    _this.state = {
      activeMessage: activeMessage,
      currentPage: currentPage,
      currentPageItems: []
    };
    return _this;
  }

  _createClass(InternalMessagesInbox, [{
    key: 'render',
    value: function render() {
      var messages = this.props.messages;


      return messages && messages.length ? this.renderMessages() : this.renderEmptyMessages();
    }
  }]);

  return InternalMessagesInbox;
}(PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getExcerpt = function (content) {
    var excerptContainer = document.createElement('template');
    excerptContainer.innerHTML = content;
    var contentChildren = excerptContainer.content.children;
    var excerpt = '';
    for (var index = 0; index < contentChildren.length; index++) {
      excerpt = excerpt + ' ' + (index === 0 ? '' : '<br>') + contentChildren.item(index).innerHTML;
    }
    return excerpt;
  };

  this.onItemClick = function (message) {
    var activeMessage = _this2.state.activeMessage;
    var itemClickCallback = _this2.props.itemClickCallback;


    _this2.setState(_extends({}, _this2.state, {
      activeMessage: activeMessage === message.Id ? false : message.Id
    }));

    if (itemClickCallback) itemClickCallback(message);
  };

  this.onChangePage = function (currentPageItems) {
    return _this2.setState(_extends({}, _this2.state, {
      currentPageItems: currentPageItems
    }));
  };

  this.runCustomCtaAction = function (e, action, value) {
    var _props = _this2.props,
        customActions = _props.customActions,
        onClickMessageCta = _props.onClickMessageCta;


    onClickMessageCta(e);
    if (!(action && value)) return null;

    var shouldRunCustomAction = action && customActions.hasOwnProperty(action.toLowerCase()) && value;

    var customAction = customActions[action.toLowerCase()];
    if (!shouldRunCustomAction || typeof customAction !== 'function') return null;

    e.preventDefault();
    customAction(value);
  };

  this.renderCta = function (message) {
    var formatMessage = _this2.props.intl.formatMessage;
    var _message$Attributes = message.Attributes,
        ctaTranslationKey = _message$Attributes.ctaTranslationKey,
        ctaAction = _message$Attributes.ctaAction;

    if (!(ctaTranslationKey && ctaAction)) return null;

    var _ctaAction$split = ctaAction.split('='),
        _ctaAction$split2 = _slicedToArray(_ctaAction$split, 2),
        action = _ctaAction$split2[0],
        value = _ctaAction$split2[1];

    return React.createElement(
      'a',
      {
        className: 'button primary small',
        href: ctaAction,
        onClick: function onClick(e) {
          return _this2.runCustomCtaAction(e, action, value);
        } },
      message.Provider === 'fasttrack' ? ctaTranslationKey : formatMessage({
        id: ctaTranslationKey,
        defaultMessage: 'Claim'
      })
    );
  };

  this.renderListItemHeader = function (message) {
    var Id = message.Id,
        Title = message.Title,
        StartDate = message.StartDate,
        IconUrl = message.IconUrl;

    var isOpen = _this2.state.activeMessage === Id;

    return React.createElement(
      'header',
      { onClick: function onClick() {
          return isOpen ? _this2.onItemClick(message) : null;
        } },
      React.createElement(
        'div',
        { className: 'header-row' },
        IconUrl && React.createElement('img', { className: 'icon', src: IconUrl }),
        React.createElement(
          'h3',
          { className: 'title' },
          Title
        ),
        React.createElement(Icon, {
          icon: 'angle-down',
          className: 'caret ' + (isOpen ? 'flipIcon' : '')
        })
      ),
      React.createElement(
        'div',
        { className: 'header-row' },
        React.createElement(
          'span',
          { className: 'time' },
          React.createElement(FormattedRelativeTime, selectUnit(new Date(StartDate)))
        )
      )
    );
  };

  this.renderListItemContent = function (message) {
    var Content = message.Content,
        Id = message.Id;

    var isOpen = _this2.state.activeMessage === Id;
    return React.createElement(
      AnimateHeight,
      {
        duration: 170,
        height: isOpen ? 'auto' : 50,
        easing: 'ease-in',
        className: 'message-wrapper' },
      React.createElement('div', {
        className: 'message',
        dangerouslySetInnerHTML: {
          __html: isOpen ? Content : _this2.getExcerpt(Content)
        }
      }),
      isOpen && _this2.renderCta(message)
    );
  };

  this.renderListItem = function (message) {
    var Id = message.Id,
        Status = message.Status;

    var isOpen = _this2.state.activeMessage === Id;

    return React.createElement(
      'article',
      {
        key: Id,
        className: 'messages-list-item ' + (Status ? Status.toLowerCase() : '') + ' ' + (isOpen ? 'open' : ''),
        onClick: function onClick() {
          return !isOpen ? _this2.onItemClick(message) : null;
        } },
      _this2.renderListItemHeader(message),
      _this2.renderListItemContent(message)
    );
  };

  this.renderPagination = function () {
    return React.createElement(Pagination, {
      items: _this2.props.messages,
      initialPage: _this2.state.currentPage,
      onChangePage: _this2.onChangePage,
      pageSize: _this2.props.pageSize,
      isPageVisible: _this2.props.isPageVisible,
      persistStep: true
    });
  };

  this.renderMessages = function () {
    var _state = _this2.state,
        currentPageItems = _state.currentPageItems,
        activeMessage = _state.activeMessage;


    return React.createElement(
      'section',
      { className: 'messages-list ' + (activeMessage ? 'active' : '') },
      currentPageItems.map(function (message) {
        return _this2.renderListItem(message);
      }),
      React.createElement(
        'footer',
        { className: 'pagination' },
        _this2.renderPagination()
      )
    );
  };

  this.renderEmptyMessages = function () {
    return React.createElement(
      'section',
      { className: 'messages-list-empty-messages' },
      React.createElement(Icon, { icon: 'envelope' }),
      React.createElement(Translate, {
        tagName: 'p',
        id: 'label.internal-messaging.no-messages',
        defaultMessage: 'No messages'
      })
    );
  };
};

InternalMessagesInbox.propTypes = {
  messages: PropTypes.array.isRequired,
  pageSize: PropTypes.number,
  isPageVisible: PropTypes.bool,
  initialMessage: PropTypes.number,
  itemClickCallback: PropTypes.func
};

InternalMessagesInbox.defaultProps = {
  pageSize: 10,
  isPageVisible: true
};

export default injectIntl(InternalMessagesInbox);